import { useNavigate } from 'react-router-dom'
import GardenReopenCard from './GardenReopenCard'
import { useLayoutEffect, useState } from 'react'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'

export default function GardenReopenCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const navigate = useNavigate()

    const ReopenWorkProgressNavigate = (name, screenFlag) => {
        if (name === "Reopen Assign") {
            if (activeButton == 0) {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Garden_ReopenAssign&Flag=Garden_ReopenAssign&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Civil_ReopenAssign&Flag=Civil_ReopenAssign&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        } else if (name === "Reopen Pending") {
            if (activeButton == 0) {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Garden_ReopenPending&Flag=Garden_ReopenPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Civil_ReopenPending&Flag=Civil_ReopenPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        } else if (name === "Reopen Completed") {
            if (activeButton == 0) {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Garden_ReopenCompleted&Flag=Garden_ReopenCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Civil_ReopenCompleted&Flag=Civil_ReopenCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        }
    }

    const [activeButton, setActiveButton] = useState(sessionStorage.getItem('Axg') ? sessionStorage.getItem('Axg') : 0);

    useLayoutEffect(() => {
        setActiveButton(sessionStorage.getItem('Axg') ? sessionStorage.getItem('Axg') : 0)
    }, [])

    const handleButtonClick = (index) => {
        sessionStorage.setItem('Axg', index)
        setActiveButton(index);
    };

    const ReopenWorkProgressdata = {
        labels: ["Reopen Assign", "Reopen Pending", "Reopen Completed"],
        datasets: [
            {
                // label: '# of Votes',
                data: [
                    activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Assign_TotalCount : Countdata?.Civil_ReopenAssignWork_Assign_TotalCount,
                    activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Pending_TotalCount : Countdata?.Civil_ReopenAssignWork_Pending_TotalCount,
                    activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Completed_TotalCount : Countdata?.Civil_ReopenAssignWork_Completed_TotalCount
                ],
                backgroundColor: [
                    "#41b2b0",
                    "#f38242",
                    "#293d7c",

                    // "#293d7c",
                    // "#41b2b0",
                    // "#f38242",

                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='row m-1 p-0  bg-white' style={{ border: '1px solid #0d467ee6', borderRadius: '8px ' }}>
            <div className='py-2 mb-0 border5 d-flex justify-content-between'>
                <div>
                    <h5 className="pt-2 ">Reopen Work Progress</h5>
                </div>

                <div className="btn-group float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid #154779', borderRadius: '5px', }}>
                    <button
                        onClick={() => handleButtonClick(0)}
                        className={activeButton == 0 ? "btn fw-bold px-4 activebutton text-white" : "text-black fw-bold btn px-4"}
                    >Garden</button>
                    <button
                        onClick={() => handleButtonClick(1)}
                        className={activeButton == 1 ? "btn px-4 fw-bold activebutton text-white" : "text-black fw-bold btn px-4"}
                        type="button">Civil</button>
                </div>
            </div>
            <div className="col-12 col-lg-9">
                <div className="row pb-2 pt-3">

                    <div className="col-12 col-md-6 col-lg-4">
                        <GardenReopenCard
                            title="Reopen Assign"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/assignment.png'
                            count={activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Assign_TotalCount : Countdata?.Civil_ReopenAssignWork_Assign_TotalCount}
                            // navLink='/gardenreopenpending'
                            ReopenWorkProgressNavigate={ReopenWorkProgressNavigate}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <GardenReopenCard
                            title="Reopen Pending"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/ReopenPending2.png'
                            count={activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Pending_TotalCount : Countdata?.Civil_ReopenAssignWork_Pending_TotalCount}
                            // navLink='/gardenreopenpending'
                            ReopenWorkProgressNavigate={ReopenWorkProgressNavigate}
                        />
                    </div>

                    <div className="col-12 col-md-6 col-lg-4">
                        <GardenReopenCard
                            title="Reopen Completed"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/ReopenCompleted.png'
                            count={activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Completed_TotalCount : Countdata?.Civil_ReopenAssignWork_Completed_TotalCount}
                            navLink='/gardereopencomplete'
                            ReopenWorkProgressNavigate={ReopenWorkProgressNavigate}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-3 pb-lg-2">
                {
                    (activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Assign_TotalCount : Countdata?.Civil_ReopenAssignWork_Assign_TotalCount != 0)
                        || (activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Pending_TotalCount : Countdata?.Civil_ReopenAssignWork_Pending_TotalCount != 0) ||
                        (activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Completed_TotalCount : Countdata?.Civil_ReopenAssignWork_Completed_TotalCount != 0) ?
                        <Pie
                            height={200}
                            // width={100}
                            options={Pieoptions}
                            data={ReopenWorkProgressdata}
                        />
                        :
                        <div className='text-danger text-center pt-lg-5 fw-bolder'>
                            No Data Found
                        </div>
                }
            </div>
        </div>
    )

}
